export default {
  '--input-input-text-color': '#fff',
  '--input-blur-color': 'rgb(255, 255, 255, .7)'
};